// noinspection JSAnnotator
const state = {
  companies: [],
  company: [],
  companyId: 0
};

// noinspection JSAnnotator
const mutations = {
  'SET_COMPANY_DETAILS'(state, detail) {
    state.company = [];
    state.companyId = 0;
    if (detail) {
      state.company = detail;
      state.companyId = detail.companyId;
    }
  },
  'GET_COMPANY_DETAILS'() {
    return state.company;
  },
  'UPDATE_COMPANY_DETAILS'(state, detail) {
    state.company.unshift(detail);
  },
  'REMOVE_COMPANY_DETAILS'() {
    state.company = [];
  },

  'SET_COMPANIES_DETAILS'(state, detail) {
    state.companies = [];
    if (detail) {
      if (detail.length > 0) {
        state.companies = detail;
      }
    }
  },
  'GET_COMPANIES_DETAILS'() {
    return state.companies;
  },
  'UPDATE_COMPANIES_DETAILS'(state, detail) {
    state.companies.unshift(detail);
  },
  'REMOVE_COMPANIES_DETAILS'() {
    state.companies = [];
  },
};

const actions = {
  getCompanyDetail: ({commit}, detail) => {
    commit('GET_COMPANY_DETAILS', detail);
  },
  setCompanyDetail: ({commit}, detail) => {
    commit('SET_COMPANY_DETAILS', detail);
  },
  updateCompanyDetail: ({commit}, detail) => {
    commit('UPDATE_COMPANY_DETAILS', detail);
  },

  getCompanyListDetail: ({commit}, detail) => {
    commit('GET_COMPANIES_DETAILS', detail);
  },
  setCompanyListDetail: ({commit}, detail) => {
    commit('SET_COMPANIES_DETAILS', detail);
  },
  updateCompanyListDetail: ({commit}, detail) => {
    commit('UPDATE_COMPANIES_DETAILS', detail);
  },
  removeCompanyList: ({commit}, detail) => {
    commit('REMOVE_COMPANIES_DETAILS', detail);
  }
};

const getters = {
  getCompanyListDetail: () => {
    return state.companies;
  },
  getCompanyDetail: (state) => {
    return state.company;
  },
  getCompanyId: (state) => {
    return state.companyId;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};




// WEBPACK FOOTER //
// ./src/store/modules/Company.store.js